import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { NotificationTemplatesModalType } from '@/modules/configurationModule/detail/notifications/components/notification-templates-modal/notification-templates-modal.model'
import { getEnumColumnGridOptions } from '@/grid/base-grid-options'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { predefinedCustomNotificationConfigurationService } from '@/modules/configurationModule/detail/notifications/services/predefined-custom-notification/predefined-custom-notification.service'
import { store } from '@/store/store'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { PredefinedCustomNotificationResponse } from '@/modules/configurationModule/detail/notifications/services/predefined-custom-notification/predefined-custom-notification.dto'

export const columnsDefNotificationTypesGrid =
    (notificationTemplatesModalTypes: NotificationTemplatesModalType[]): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('configuration.grid.predefinedNotification'),
            type: AgGridColumnType.TEXT,
            field: 'title',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            ...getEnumColumnGridOptions(notificationTemplatesModalTypes, 'code', 'translatedName'),
            headerName: i18n.tc('configuration.grid.type'),
            type: AgGridColumnType.TEXT,
            colId: 'type',
            field: 'type.translatedName',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('configuration.grid.active'),
            type: AgGridColumnType.CHECK_ICON,
            field: 'active',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        }
    ]

export interface NotificationsPredefinedTemplatesGridState extends CrudModelPaginatorLaboratory<PredefinedCustomNotificationResponse> {
    service: typeof predefinedCustomNotificationConfigurationService
    laboratoryId: number
}
export const initialNotificationsPredefinedTemplatesGridState =
    (): NotificationsPredefinedTemplatesGridState => ({
        ...initialCrudModelBaseState(),
        service: predefinedCustomNotificationConfigurationService,
        laboratoryId: store.getters.labId,
        datasource: new PaginatorLaboratoryDatasource(predefinedCustomNotificationConfigurationService, store.getters.labId),
        columnsDef: columnsDefNotificationTypesGrid([]),
        gridUiComponent: 'uicomponent.configuration.local.notifications.predefinedTemplatesGrid'
    })
